import { jsx } from "react/jsx-runtime";
import { AdBuilderUI } from "../AdBuilder/AdBuilderUI/index.js";
import { CategoryTileUI } from "../CategoryTile/CategoryTileUI/index.js";
import { FeatureHighlightCardUI } from "../FeatureHighlightCard/index.js";
import { fourCornersCateogryTileStyles } from "../FourCornersCategoryTile/tile.styles.js";
import { COMPONENT_NAME, FEATURE_HIGHLIGHT_COMPONENT, CATEGORY_TILE, AD_BUILDER_COMPONENT } from "./constants.js";
const CardComposer = ({
  componentType,
  data,
  externalLinkModule
}) => {
  switch (componentType) {
    case AD_BUILDER_COMPONENT:
      return /* @__PURE__ */ jsx(
        AdBuilderUI,
        {
          ...data,
          data,
          externalLinkModule
        }
      );
    case CATEGORY_TILE: {
      return /* @__PURE__ */ jsx(
        CategoryTileUI,
        {
          ...data,
          ...fourCornersCateogryTileStyles
        }
      );
    }
    case FEATURE_HIGHLIGHT_COMPONENT:
      return /* @__PURE__ */ jsx(
        FeatureHighlightCardUI,
        {
          data
        }
      );
    default:
      console.error(
        `"${componentType}" is not a valid component type. ${COMPONENT_NAME}`
      );
      return null;
  }
};
CardComposer.displayName = COMPONENT_NAME;
export {
  CardComposer
};
